var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSharedFoldersLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.161
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152 -1098) translate(101 90) translate(0 992) translate(51 16) translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.984,
    cy: 21.683,
    fill: "#EEF0F3",
    rx: 4.016,
    ry: 4.002
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.984,
    cy: 33.998,
    fill: "#EEF0F3",
    rx: 4.016,
    ry: 4.002
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.628,
    cy: 29.072,
    fill: "#EEF0F3",
    rx: 4.016,
    ry: 4.002
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.335 26.609L30.277 23.53M25.335 30.919L29.66 32.766M32.804 13.422V7.515c0-1.533-.12-2.56-2.527-2.56h-13.89c-2.235 0-2.474-.223-3.095-1.371-.62-1.148-.643-1.413-1.31-2.382C11.318.234 10.976 0 9.025 0H2.31C-.105 0 .001 1.725.001 3.8v21.058c0 1.751.354 3.103 2.31 3.103h11.623"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedFoldersLarge);
export default __webpack_public_path__ + "static/media/shared-folders-large.619899f1482f0d2ae1a51a2736a79f02.svg";
export { ForwardRef as ReactComponent };